document.addEventListener('click',event=>{
 const thumb=event.target.closest('[data-gallery-target]');
 if(thumb){const gallery=thumb.closest('.bb-gallery');gallery.querySelectorAll('[data-gallery-image]').forEach(image=>{image.hidden=image.dataset.galleryImage!==thumb.dataset.galleryTarget;});return;}
 const size=event.target.closest('[data-variant-id]');
 if(!size||size.disabled)return;
 const form=size.closest('form');
 form.querySelector('[name="id"]').value=size.dataset.variantId;
 form.querySelectorAll('[data-variant-id]').forEach(button=>button.setAttribute('aria-pressed',String(button===size)));
 const price=form.closest('.bb-purchase').querySelector('[data-price]');
 if(price){
  const currentPrice=price.querySelector('[data-price-current]');
  if(currentPrice){
   currentPrice.textContent=size.dataset.price;
   const compareWrap=price.querySelector('[data-price-compare-wrap]');
   const comparePrice=price.querySelector('[data-price-compare]');
   const priceLabel=price.querySelector('[data-price-label]');
   const onSale=Boolean(size.dataset.comparePrice);
   if(comparePrice)comparePrice.textContent=size.dataset.comparePrice||'';
   if(compareWrap)compareWrap.hidden=!onSale;
   if(priceLabel)priceLabel.textContent=(onSale?price.dataset.saleLabel:price.dataset.regularLabel)+' ';
  }else{price.textContent=size.dataset.price;}
 }
 form.querySelector('[name="add"]').disabled=size.dataset.available!=='true';
 const url=new URL(window.location.href);url.searchParams.set('variant',size.dataset.variantId);window.history.replaceState({},'',url);
});
